const formDataSchema ={
    feilds: [{
        id: 1,
        name: 'privilege_name',
        title: 'Privilege Name*',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter Privilege Name',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Privilege Name'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2'
    }, {
        id: 2,
        name: 'emergency',
        title: 'Emergency*',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Emergency'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2'
    },{
        id: 3,
        name: 'form_type',
        title: 'Form Type*',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value !== 0);
                },
                message: 'Please Select Form Type'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2'
    }
    ,{
        id: 3,
        name: 'time_duration',
        title: 'Default Time Duration',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter Default Time Duration(min)',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value!== 0);
                    
                },
                message: 'Please Enter DTD'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2'
    },
    {
        id: 4,
        name: 'admission',
        title: 'Admisson*',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Admission'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2 w-2'
    },
    {
        id: 5,
        name: 'whatsapp',
        title: 'Send Whatsapp*',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Yes/No'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-2'
    },
    ]
}

export {formDataSchema};